<template>
    <Component
        :is="element"
        class="base-chip"
        unstyled
        :class="{
            'base-chip--small': small,
            'base-chip--large': large,
            'base-chip--responsive': !small && !large,
            'base-chip--active': active
        }"
    >
        <slot />
        <Icon
            v-if="active && withIcon"
            name="app:close"
        />
    </Component>
</template>

<script setup>
defineProps({
    element: {
        type: [String, Object],
        required: false,
        default: 'button'
    },
    small: {
        type: Boolean,
        default: false
    },
    large: {
        type: Boolean,
        default: false
    },
    active: {
        type: Boolean,
        default: false
    },
    withIcon: {
        type: Boolean,
        default: true
    }
});
</script>

<style src="./BaseChip.less" lang="less" />
